import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterVacancyMetricState {
  data: any;
}

export const ShelterVacancyMetric = ({ data }: ShelterVacancyMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [vacant, setVacant] = useState<string>();

  useEffect(() => {
    if (data) {
      const { occupancy } = data;
      const empty = occupancy?.filter((item: any) => item.occupant_id === null).length;
      setVacant(empty?.toString());
    }
    setIsLoading(false);
  }, [data]);

  return <SingleCardMetric title={"Vacant Beds"} total={vacant} isLoading={isLoading} />;
};
